import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import CheckoutContent,{AppWithRouter} from '../components/CheckoutContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';

class Cart extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        return (
            <div>
                <Header/> 
                <PageHeader title="Checkout"  />
                <AppWithRouter />  
                <Footer/>
      
        
        </div>
       
        )
    }

}
export default withRouter(Cart);;